import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAgendamentoStepIndicator } from "../../../hooks/useAgendamentoStepIndicator";
import { OpcoesServicosEnum } from "../../../enums/opcoesServicos";
import { Tracking } from "../../../services/Tracking";

const ROTA_POR_SERVICO: Record<OpcoesServicosEnum, string> = {
  [OpcoesServicosEnum.VISTORIA]: "vistoria",
  [OpcoesServicosEnum.EMPLACAMENTO]: "emplacamento",
  [OpcoesServicosEnum.PRIMEIRO_REGISTRO]: "primeiro-registro",
};

export const useServicesV2 = () => {
  const navigate = useNavigate();
  const { uuidAgendamento } = useParams();
  const stepIndicator = useAgendamentoStepIndicator();
  const [servicoSelecionado, setServicoSelecionado] =
    useState<OpcoesServicosEnum | null>(null);

  function handleSelect(opcao: OpcoesServicosEnum) {
    setServicoSelecionado(opcao);
    Tracking.userAction("mapa:agendamento/servicos:clique-selecionar-servico");
  }

  function handleAvancar() {
    if (!servicoSelecionado) return;

    Tracking.userAction("mapa:agendamento/servicos:clique-botao-avancar");
    navigate(
      `/agendamento/${uuidAgendamento}/servicos/${ROTA_POR_SERVICO[servicoSelecionado]}`,
    );
  }

  return {
    stepIndicator,
    servicoSelecionado,
    handleSelect,
    handleAvancar,
  };
};
